import { InlineScript } from "./inline-script";

/** La clave de `localStorage`. Compartida con `TemaToggle` — si cambia acá, cambia allá. */
export const CLAVE_TEMA = "vecipp-ayuda-tema";

/**
 * Pone la clase `dark` en `<html>` **antes de que el navegador pinte**.
 *
 * 🔑 **Por eso es un script en línea en el `<head>` y no un `useEffect`.** Con `useEffect` la página se
 * pinta primero en claro y se vuelve oscura al hidratar: el destello blanco de siempre, que en un sitio
 * de lectura y a oscuras molesta de verdad. Es el mismo patrón que ya usan `accent-boot.tsx` y
 * `reveal-boot.tsx` en este archivo de al lado.
 *
 * ⚠️ **Sin preferencia guardada sigue al sistema** (`prefers-color-scheme`), y solo se queda fijo cuando
 * el visitante toca el botón. Es lo que hace la referencia, cuyo selector viene en «Auto» de fábrica.
 *
 * ⚠️ **Todo va dentro de un `try`**: en navegación privada `localStorage` puede lanzar al leerlo, y un
 * error acá —antes de pintar— dejaría la página en blanco.
 */
export function TemaBootScript() {
  const code = `
    (function () {
      try {
        var guardado = null;
        try { guardado = window.localStorage.getItem(${JSON.stringify(CLAVE_TEMA)}); } catch (e) {}
        var oscuro = guardado === "oscuro" ||
          (guardado !== "claro" && window.matchMedia("(prefers-color-scheme: dark)").matches);
        document.documentElement.classList.toggle("dark", oscuro);
      } catch (e) {}
    })();
  `;
  return <InlineScript html={code} />;
}
